/**
 * Constantes centralisees pour la gestion des roles utilisateur.
 *
 * Distinction importante :
 *  - ACCESS_TYPES = niveaux de privilege technique (admin / superadmin / user / developpeur)
 *    -> stocke dans `user.role`, controle l'acces aux modules/pages/admin
 *  - BUSINESS_ROLES = roles fonctionnels metier (formateur, stagiaire, comptable, etc.)
 *    -> stocke dans `user.roles[]` (tableau, plusieurs roles possibles)
 *    -> determine quels espaces metier l'utilisateur voit (Espace formateur, Espace stagiaire, etc.)
 *
 * Exemple : un utilisateur peut etre `role=admin` + `roles=["formateur", "comptable"]`
 *  -> il a tous les droits techniques + voit les espaces Formateur et Comptable
 */

export const ACCESS_TYPES = [
  { value: "superadmin", label: "Master Admin", color: "#f7c935", desc: "Gestion multi-tenants : offres, plateforme, tous les tenants" },
  { value: "admin",      label: "Admin",        color: "#3b82f6", desc: "Gestion complete de sa plateforme (equipe, clients, modules)" },
];

export const BUSINESS_ROLES = [
  { value: "dirigeant",     label: "Dirigeant",     color: "#dc2626", desc: "Direction generale, vision strategique, decisions executives" },
  { value: "rh",            label: "RH",            color: "#f97316", desc: "Ressources humaines, recrutement, paie, conformite sociale" },
  { value: "gestionnaire",  label: "Gestionnaire",  color: "#0ea5e9", desc: "Gestion d'equipe, suivi operationnel, reporting" },
  { value: "formateur",     label: "Formateur",     color: "#8b5cf6", desc: "Acces espace formateur + sessions LMS + apprenants" },
  { value: "stagiaire",     label: "Stagiaire",     color: "#06b6d4", desc: "Acces espace stagiaire + parcours formation" },
  { value: "comptable",     label: "Comptable",     color: "#10b981", desc: "Acces module comptabilite + exports FEC + notes de frais" },
  { value: "coach",         label: "Coach",         color: "#a855f7", desc: "Acces accompagnements + audits + clients suivis" },
  { value: "commercial",    label: "Commercial",    color: "#ec4899", desc: "Acces CRM, prospects, facturation, scoring IA" },
  { value: "marketing",     label: "Marketing",     color: "#f59e0b", desc: "Reseaux sociaux, mailing, audiences IA, ROAS" },
  { value: "support",       label: "Support",       color: "#3b82f6", desc: "Service client, tickets, reponses, conversations Aircall" },
  { value: "sous_traitant", label: "Sous-traitant", color: "#64748b", desc: "Acces missions externes uniquement, prestataire freelance" },
];

// Roles tenant (multi-tenant) — distincts des access types globaux
export const TENANT_ROLES = [
  { value: "tenant_admin",  label: "Admin",   color: "#f7c935", desc: "Gere la plateforme : modules, equipe, parametres" },
  { value: "tenant_member", label: "Salarié", color: "#94a3b8", desc: "Droits definis par son poste" },
];

export const ACCESS_LABELS = Object.fromEntries(ACCESS_TYPES.map(r => [r.value, r.label]));
export const ACCESS_COLORS = Object.fromEntries(ACCESS_TYPES.map(r => [r.value, r.color]));
export const BUSINESS_LABELS = Object.fromEntries(BUSINESS_ROLES.map(r => [r.value, r.label]));
export const BUSINESS_COLORS = Object.fromEntries(BUSINESS_ROLES.map(r => [r.value, r.color]));

// Specialites (sous-categories pour role=sous_traitant)
export const SPECIALTIES = [
  { value: "developpeur",     label: "Developpeur" },
  { value: "coach_freelance", label: "Coach" },
  { value: "comptable",       label: "Comptable" },
];
